<template>
  <div class="row">
    <div
      v-for="pkg in packages"
      :key="pkg.name"
      class="col-12 col-md-6 col-lg-4 mb-3"
    >
      <div class="card shadow-sm h-100">
        <div class="card-body">
          <div class="w-full d-flex justify-content-center">
            <img class="logo" width="150" src="/images/license.png" alt="PVS License">
          </div>
          <h5 class="card-title text-primary text-center" style="font-size: 24px; font-weight: 700">{{ pkg.name }}</h5>
          <p class="card-text">
            - Số lượng: {{ pkg.quantity.toLocaleString() }} hóa đơn<br>
            - Giá tiền: <strong class="text-primary">{{ pkg.totalPrice.toLocaleString() }} VNĐ</strong>
          </p>
          <a target="_blank" href="https://pvssolution.com/lien-he/" class="btn btn-primary w-full">Nhận tư vấn</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LicenseExpired',
  data() {
    return {
      packages: [
        { name: 'P100', quantity: 100, unitPrice: 1000, totalPrice: 100000 },
        { name: 'P300', quantity: 300, unitPrice: 900, totalPrice: 270000 },
        { name: 'P500', quantity: 500, unitPrice: 746, totalPrice: 373000 },
        { name: 'P1000', quantity: 1000, unitPrice: 580, totalPrice: 580000 },
        { name: 'P2000', quantity: 2000, unitPrice: 436, totalPrice: 872000 },
        { name: 'P3000', quantity: 3000, unitPrice: 409, totalPrice: 1227000 },
        { name: 'P5000', quantity: 5000, unitPrice: 372, totalPrice: 1860000 },
        { name: 'P7000', quantity: 7000, unitPrice: 354, totalPrice: 2478000 },
        { name: 'P10000', quantity: 10000, unitPrice: 310, totalPrice: 3100000 },
        { name: 'P15000', quantity: 15000, unitPrice: 290, totalPrice: 4350000 },
        { name: 'P20000', quantity: 20000, unitPrice: 263, totalPrice: 5260000 },
        { name: 'P50000', quantity: 50000, unitPrice: 250, totalPrice: 12500000 },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/license-expired.vue